import { useQuery } from "@apollo/client";
import Select from "../select";
import { CrudListEntities } from "gql/graphql";
import { SelectProps } from "antd";
import { GET_CRUD_ENTITY_VALUES } from "./api/get-crud-entity-values";

type EntitiesProps = SelectProps & {
  type: CrudListEntities;
};

export function Entities({ type, ...rest }: EntitiesProps) {
  const { data, previousData, loading, refetch } = useQuery(
    GET_CRUD_ENTITY_VALUES,
    {
      variables: {
        entity: type,
      },
    },
  );

  const options =
    data?.getAllCrudEntityValues ?? previousData?.getAllCrudEntityValues ?? [];

  return (
    <Select
      loading={loading}
      options={options.map((item) => ({
        label: item.name,
        value: item.id,
      }))}
      onDropdownVisibleChange={(open) => (open ? refetch() : null)}
      {...rest}
    />
  );
}
